import * as fetchDiscountCodes from 'store/actions/discountCodes/fetchDiscountCodes';
import * as createDiscountCodes from 'store/actions/discountCodes/createDiscountCodes';
import * as deleteDiscountCodes from 'store/actions/discountCodes/deleteDiscountCodes';
import * as exportDiscountCodes from 'store/actions/discountCodes/exportDiscountCodes';
import * as updateDiscountCodes from 'store/actions/discountCodes/updateDiscountCodes';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchDiscountCodesAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchDiscountCodes.fetchDiscountCodesSuccess(response));
    } catch (error) {
        yield put(fetchDiscountCodes.fetchDiscountCodesFailure(error));
    }
}

function* fetchDiscountCodeAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchDiscountCodes.fetchDiscountCodeSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchDiscountCodes.fetchDiscountCodeFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createDiscountCodeAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes`;

        const response = yield apiClient.create(url, values);

        yield put(createDiscountCodes.createDiscountCodeSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(createDiscountCodes.createDiscountCodeFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createDiscountCodeSuccessAsync() {
    yield put(showNotification('notifications.discount_codes.create.success'));
}

function* updateDiscountCodeAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateDiscountCodes.updateDiscountCodeSuccess(payload, response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(updateDiscountCodes.updateDiscountCodeFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateDiscountCodeSuccessAsync() {
    yield put(showNotification('notifications.discount_codes.update.success'));
}

function* deleteDiscountCodeAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteDiscountCodes.deleteDiscountCodeSuccess(payload));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(deleteDiscountCodes.deleteDiscountCodeFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* deleteDiscountCodeSuccessAsync() {
    yield put(showNotification('notifications.discount_codes.delete.success', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

function* exportDiscountCodesAsync({ params }) {
    try {
        const url = `${ config.getApiBaseUrl() }/discount-codes/export`;

        yield apiClient.read(url, params);

        yield put(exportDiscountCodes.exportDiscountCodesSuccess());
    } catch (error) {
        yield put(exportDiscountCodes.exportDiscountCodesFailure());
    }
}

function* exportDiscountCodesFailureAsync() {
    yield put(showNotification('notifications.export.failure'));
}

function* exportDiscountCodesSuccessAsync() {
    yield put(showNotification('notifications.export.success'));
}

export default function* usersSagas() {
    yield [
        takeEvery(types.FETCH_DISCOUNT_CODES, fetchDiscountCodesAsync),
        takeEvery(types.FETCH_DISCOUNT_CODES_FAILURE, failureMessage),

        takeEvery(types.FETCH_DISCOUNT_CODE, fetchDiscountCodeAsync),
        takeEvery(types.FETCH_DISCOUNT_CODE_FAILURE, failureMessage),

        takeEvery(types.CREATE_DISCOUNT_CODE, createDiscountCodeAsync),
        takeEvery(types.CREATE_DISCOUNT_CODE_FAILURE, failureMessage),
        takeEvery(types.CREATE_DISCOUNT_CODE_SUCCESS, createDiscountCodeSuccessAsync),

        takeEvery(types.UPDATE_DISCOUNT_CODE, updateDiscountCodeAsync),
        takeEvery(types.UPDATE_DISCOUNT_CODE_FAILURE, failureMessage),
        takeEvery(types.UPDATE_DISCOUNT_CODE_SUCCESS, updateDiscountCodeSuccessAsync),

        takeEvery(types.DELETE_DISCOUNT_CODE, deleteDiscountCodeAsync),
        takeEvery(types.DELETE_DISCOUNT_CODE_FAILURE, failureMessage),
        takeEvery(types.DELETE_DISCOUNT_CODE_SUCCESS, deleteDiscountCodeSuccessAsync),

        takeEvery(types.EXPORT_DISCOUNT_CODES, exportDiscountCodesAsync),
        takeEvery(types.EXPORT_DISCOUNT_CODES_FAILURE, exportDiscountCodesFailureAsync),
        takeEvery(types.EXPORT_DISCOUNT_CODES_SUCCESS, exportDiscountCodesSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/discountsCodesSagas.js